export interface OptionProps {
  disabled?: boolean
  hidden?: boolean
  label: string
  value: string
}

const Option = ({
  disabled = false,
  hidden = false,
  label,
  value,
}: OptionProps) => {
  return (
    <option disabled={disabled} hidden={hidden} value={value}>
      {label}
    </option>
  )
}

Option.displayName = "Select.Option"

export { Option }
